import React, { useEffect, useRef } from 'react';
import
{
    Box, TextField, Typography, Button,
} from '@mui/material';
import { createState, Downgraded, useState } from '@hookstate/core';
import validator from 'validator';
import { withRouter, Link } from 'react-router-dom';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Logo from '../../assets/images/logo.png';
import ReCAPTCHA from 'react-google-recaptcha';
import * as forge from 'node-forge';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import AzureConstant from '../../config/authConfigConstant';
import { makeStyles } from '@mui/styles';

const signupState = createState({
    firstName: '',
    lastName: '',
    email: '',
    pwd: '',
    confPwd: '',
    code: ''
});
const useStyles = makeStyles({
    linkStyle: {
        color: 'black !important',
        borderBottom: '1px solid black',
        textDecoration: 'none',
        cursor: 'pointer !important'

    },

});

const Signup = () =>
{
    const classes = useStyles();
    const state = useState(signupState);
    const [fNameErr, setFNameErr] = React.useState('');
    const [lNameErr, setLNameErr] = React.useState('');
    const [emailErr, setEmailErr] = React.useState('');
    const [pwdErr, setPwdErr] = React.useState('');
    const [confPwdErr, setConfPwdErr] = React.useState('');
    const [captchaToken, setCaptchaToken] = React.useState('');
    const recaptchaRef = React.createRef();
    const emailRef = useRef();
    const path = window.location.search;
    let params = new URLSearchParams(path);
    const [siteKey, setSiteKey] = React.useState('');
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const validateEmail = (value) =>
    {
        value = value.trim();
        if (validator.isEmail(value))
        {
            return true;
        } else return false;
    };

    useEffect(() => {
        if (window.location.href.includes(AzureConstant.PROD_APP)) {
            setSiteKey(AzureConstant.PROD_CAPTCHA_SITE_KEY);
        } else {
            setSiteKey(AzureConstant.OTHER_CAPTCHA_SITE_KEY);
        }

        const params = new URLSearchParams(window.location.search);
        const userCode = params.get('code');

        if (userCode) {
            let RETURN_URL = AzureConstant.LOCAL_APP;
            if (window.location.href.includes(AzureConstant.DEV_APP)) {
                RETURN_URL = 'https://' + AzureConstant.DEV_APP;
            } else if (window.location.href.includes(AzureConstant.QA_APP)) {
                RETURN_URL = 'https://' + AzureConstant.QA_APP;
            } else if (window.location.href.includes(AzureConstant.CT_APP)) {
                RETURN_URL = 'https://' + AzureConstant.CT_APP;
            } else if (window.location.href.includes(AzureConstant.PROD_APP)) {
                RETURN_URL = 'https://' + AzureConstant.PROD_APP;
            }

            const MAIN_URL = window.location.href.includes(AzureConstant.LOCAL_APP) ? RETURN_URL : RETURN_URL + '/';

            fetch(MAIN_URL + APIURLConstants.GET_USER_DETAILS_BY_CODE(userCode), {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })
            .then((res) => res.json())
            .then((response) => {
                state.set({
                    firstName: response.firstName,
                    lastName: response.lastName,
                    email: response.email,
                    pwd: '',
                    confPwd: '',
                });
            })
            .catch((err) => {
                // setError(err.response ? err.response.data : 'Error');
                console.error('Error fetching user details:', err);
            });
        }
    }, []);

    const isEmailExist = () =>
    {
        const email = state.email.get().trim();
        const flag = email != '' ? validateEmail(email) : true;
        const emlErr = flag ? '' : 'Please enter valid Email Login ID';
        setEmailErr(emlErr);

        if (email.length > 0 && flag)
        {
            ApiHelper.get(APIURLConstants.GET_VALID_LOGIN_ID(email)).then(
                (res) =>
                {
                    if (res.data)
                    {
                        setEmailErr('This login ID already exists');
                        // emailRef.current.focus();
                    } else
                    {
                        setEmailErr('');
                    }
                }
            );
        }
    };

    const onChangePwd = (event) =>
    {
        let password = event.target.value.trim();
        state.pwd.set(password);
    };

    const resetState = () =>
    {
        state.set({
            firstName: '',
            lastName: '',
            email: '',
            pwd: '',
            confPwd: '',
        });
    }

    const handleClick = async (event) =>
    {
        event.preventDefault();
        var isCaptchaChecked =
            recaptchaRef &&
            recaptchaRef.current.props.grecaptcha.getResponse().length !== 0;
        if (
            fNameErr.length > 0 ||
            lNameErr.length > 0 ||
            emailErr.length > 0 ||
            pwdErr.length > 0 ||
            confPwdErr.length > 0
        )
        {
            return false;
        } else if (!isCaptchaChecked)
        {
            return false;
        } else
        {
            let req = { ...state.attach(Downgraded).get() };
            const publicKey = process.env.REACT_APP_PUBLIC_KEY;
            let rsa = forge.pki.publicKeyFromPem(publicKey);

            let encryptedEmail = window.btoa(rsa.encrypt(req.email.toLowerCase()));
            req.email = encryptedEmail;
            let encryptedPassword = window.btoa(rsa.encrypt(req.pwd));
            req['captchaResponse'] = captchaToken;
            req['password'] = encryptedPassword;
            req.code = params.get('code');
            console.log('code', params.get('code'))
            delete req.pwd;
            delete req.confPwd;
            ApiHelper.post(APIURLConstants.POST_SAVE_USER, req)
                .then((res) =>
                {
                    if (res.data.status === 200)
                    {
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Registration is completed successfully',
                        });
                        setTimeout(() =>
                        {
                            resetState();
                            location.href = '/';
                        }, 1000);
                    } else
                    {
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: res.data.message,
                        });
                    }
                })
                .catch((error) =>
                {
                    let message = '';
                    if (error.response && error.response.status === 401)
                    {
                        message = 'Access denied';
                    } else
                    {
                        message = 'Error while creating user';
                    }
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                });
        }
    };

    function onChange(value)
    {
        setCaptchaToken(value);
    }
    const redirectTerms = () =>
    {
        window.open("https://www.nba.com/termsofuse")
    }
    const moveToLogin = () =>
    {
        window.location.href = '/';
    };

    return (
        <>
            <Box
                sx={{
                    position: 'fixed',
                    top: '22%',
                    left: '50%',
                    bottom: '40%',
                    transform: 'translate(-50%, -50%)',
                }}>
                <Box className="registerBox">
                    <Box className="loginHeader">
                        <Box
                            component="img"
                            alt="logo."
                            src={Logo}
                            sx={{ height: 42 }}
                        />
                    </Box>

                    <Box className="loginContentBox">
                        <Box
                            component="form"
                            onSubmit={handleClick}
                            autoComplete="off"
                            sx={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                            <Typography
                                variant="h4"
                                fontSize={{ xs: '16px', md: '16px' }}
                                color="#C8102E"
                                autoComplete="off"
                                fontWeight={400}>
                                Create new account
                            </Typography>
                            <Box className="regTextContent">
                                <TextField
                                    required
                                    sx={{
                                        width: '100%',
                                        marginTop: '10px',
                                    }}
                                    autoComplete="off"
                                    size="small"
                                    label="First Name"
                                    value={state.firstName.get()}
                                    onChange={(event) =>
                                    {
                                        let str = event.target.value;
                                        str = str.replace(/^\s+/g, '');

                                        if (
                                            validator.isAlpha(str, 'en-US', {
                                                ignore: ' ',
                                            })
                                        )
                                        {
                                            setFNameErr('');
                                        } else
                                        {
                                            setFNameErr(
                                                'Please enter valid first name'
                                            );
                                        }
                                        state.firstName.set(str);
                                    }}
                                    inputProps={{
                                        maxLength: 50,
                                    }}
                                    error={fNameErr.length > 0 ? true : false}
                                    helperText={
                                        fNameErr.length > 0 ? fNameErr : ''
                                    }
                                />
                            </Box>
                            <Box className="regTextContent">
                                <TextField
                                    required
                                    sx={{
                                        width: '100%',
                                        marginTop: '10px',
                                    }}
                                    autoComplete="off"
                                    size="small"
                                    label="Last Name"
                                    value={state.lastName.get()}
                                    onChange={(event) =>
                                    {
                                        let str = event.target.value;
                                        str = str.replace(/^\s+/g, '');

                                        if (
                                            validator.isAlpha(str, 'en-US', {
                                                ignore: ' ',
                                            })
                                        )
                                        {
                                            setLNameErr('');
                                        } else
                                        {
                                            setLNameErr(
                                                'Please enter valid last name'
                                            );
                                        }
                                        state.lastName.set(str);
                                    }}
                                    inputProps={{
                                        maxLength: 50,
                                    }}
                                    error={lNameErr.length > 0 ? true : false}
                                    helperText={
                                        lNameErr.length > 0 ? lNameErr : ''
                                    }
                                />
                            </Box>
                            <Box className="regTextContent">
                                <TextField
                                    required
                                    sx={{
                                        width: '100%',
                                        marginTop: '10px',
                                    }}
                                    inputRef={emailRef}
                                    size="small"
                                    autoComplete="off"
                                    label="Email"
                                    value={state.email.get()}
                                    onChange={(event) =>
                                    {
                                        let str = event.target.value;
                                        str = str.replace(/^\s+/g, '');
                                        state.email.set(str);
                                    }}
                                    onBlur={() => isEmailExist()}
                                    inputProps={{
                                        maxLength: 255,
                                    }}
                                    error={emailErr.length > 0 ? true : false}
                                    helperText={
                                        emailErr.length > 0 ? emailErr : ''
                                    }
                                />
                            </Box>
                            <Box className="regTextContent">
                                <TextField
                                    required
                                    sx={{
                                        width: '100%',
                                        marginTop: '10px',
                                    }}
                                    size="small"
                                    autoComplete="off"
                                    label="Create Password"
                                    value={state.pwd.get()}
                                    type="password"
                                    onChange={(event) => onChangePwd(event)}
                                    onBlur={() =>
                                    {
                                        if (state.pwd.get().length < 5)
                                        {
                                            setPwdErr(
                                                'Use 5 characters or more for your password'
                                            );
                                        } else
                                        {
                                            setPwdErr('');
                                        }
                                    }}
                                    inputProps={{
                                        maxLength: 30,
                                    }}
                                    error={pwdErr.length > 0 ? true : false}
                                    helperText={pwdErr.length > 0 ? pwdErr : ''}
                                />
                            </Box>
                            <Box className="regTextContent">
                                <div style={styles.statusBar}>
                                    <div
                                        style={{
                                            height: '100%',
                                            maxWidth: '100%',
                                            backgroundColor: `${state.pwd.get().length <= 6
                                                ? 'red'
                                                : state.pwd.get().length <=
                                                    8
                                                    ? 'orange'
                                                    : 'green'
                                                }`,
                                            width: `${(state.pwd.get().length / 16) *
                                                100
                                                }%`,
                                        }}></div>
                                </div>
                            </Box>
                            <Box className="regTextContent">
                                <TextField
                                    required
                                    sx={{
                                        width: '100%',
                                        marginTop: '10px',
                                    }}
                                    size="small"
                                    autoComplete="off"
                                    label="Confirm Password"
                                    type="password"
                                    value={state.confPwd.get()}
                                    onChange={(event) =>
                                    {
                                        let str = event.target.value.trim();
                                        state.confPwd.set(str);
                                    }}
                                    onBlur={() =>
                                    {
                                        if (
                                            state.confPwd.get() ==
                                            state.pwd.get()
                                        )
                                        {
                                            setConfPwdErr('');
                                        } else
                                        {
                                            setConfPwdErr(
                                                `Password didn't match. Try again`
                                            );
                                        }
                                    }}
                                    inputProps={{
                                        maxLength: 50,
                                    }}
                                    error={confPwdErr.length > 0 ? true : false}
                                    helperText={
                                        confPwdErr.length > 0 ? confPwdErr : ''
                                    }
                                />
                            </Box>
                            <Box className="regTextContent">
                                <Box sx={{ marginTop: '10px' }}>
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        sitekey={siteKey}
                                        onChange={onChange}
                                        size="normal"
                                    />
                                </Box>
                            </Box>
                            <Box><Typography >I agree to the <span className={classes.linkStyle}
                                // href="https://www.nba.com/termsofuse"
                                onClick={redirectTerms}
                            >Terms of Use </span> and <Link className={classes.linkStyle} to="/privacy-policy">  Privacy Policy.</Link></Typography></Box>
                            <Box className="regTextContent">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="secondary"
                                    sx={{ width: '100%', marginTop: '10px' }}>
                                    Sign Up
                                </Button>
                            </Box>
                            <Typography
                                variant="h4"
                                fontSize={{ xs: '13px', md: '17px' }}
                                sx={{ marginTop: '10px', cursor: 'pointer' }}
                                color="#1D428A"
                                fontWeight={400}
                                onClick={moveToLogin}>
                                Already have an Account? Sign In
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </>
    );
};

const styles = {
    statusBar: {
        width: 290,
        height: 10,
        marginTop: 10,
        background: '#fff',
        border: '1px solid #444',
        borderRadius: '5px',
    },
};
export default withRouter(Signup);
